export const REMOTE_URL = 'wss://sprinter.betapanda.co.uk/client';
export const REMOTE_DEVICE_ID = 'sprinter';
export const REMOTE_TOKEN_KEY = 'smart-sprinter.remote-token';

export function connectRemote({ url, deviceId, token, password }, onBytes, onDisconnect,
  onProgress = () => {}, onToken = () => {}, onStatus = () => {}) {
  return new Promise((resolve, reject) => {
    if (new URL(url).protocol !== 'wss:') {
      reject(new Error('Internet control requires a secure wss:// relay URL'));
      return;
    }
    let live = true;
    let authenticated = false;
    let timer;
    const socket = new WebSocket(url);
    socket.binaryType = 'arraybuffer';
    const finishError = error => {
      if (!live) return;
      live = false;
      clearTimeout(timer);
      socket.close();
      if (authenticated) onDisconnect();
      else reject(error);
    };
    timer = setTimeout(() => finishError(new Error('Internet connection timed out')), 15000);
    onProgress('Connecting to vehicle over internet');

    socket.addEventListener('open', () => {
      socket.send(JSON.stringify(token
        ? { type: 'client', deviceId, token }
        : { type: 'login', password }));
    });
    socket.addEventListener('message', event => {
      if (!live) return;
      if (!authenticated) {
        let response;
        try {
          response = JSON.parse(event.data);
        } catch {
          finishError(new Error('Invalid response from relay'));
          return;
        }
        if (response.type === 'token' && typeof response.token === 'string' && response.token) {
          token = response.token;
          onToken(token);
          socket.send(JSON.stringify({ type: 'client', deviceId, token }));
          return;
        }
        if (response.type !== 'authenticated') {
          finishError(new Error(response.message || 'Relay authentication failed'));
          return;
        }
        authenticated = true;
        clearTimeout(timer);
        resolve({
          send(bytes) {
            if (!live || socket.readyState !== WebSocket.OPEN) throw new Error('Internet connection closed');
            socket.send(bytes);
          },
          close() {
            if (!live) return;
            live = false;
            socket.close();
          },
        });
        return;
      }
      if (typeof event.data === 'string') {
        try {
          const status = JSON.parse(event.data);
          if (status.type === 'status' && Number.isInteger(status.signalDbm)) {
            onStatus(status);
            return;
          }
        } catch {}
      }
      if (!(event.data instanceof ArrayBuffer)) {
        finishError(new Error('Relay sent non-binary gateway data'));
        return;
      }
      try {
        onBytes(new Uint8Array(event.data));
      } catch (error) {
        finishError(error);
      }
    });
    socket.addEventListener('error', () => {
      if (!authenticated) finishError(new Error('Could not connect to the vehicle relay'));
    });
    socket.addEventListener('close', event => {
      if (!live) return;
      live = false;
      clearTimeout(timer);
      if (authenticated) onDisconnect();
      else if (event.code === 4001) {
        if (!password) onToken(null);
        reject(new Error(password ? 'Incorrect password' : 'Saved access is no longer valid'));
      }
      else if (event.code === 4006)
        reject(new Error('Vehicle gateway is offline'));
      else
        reject(new Error(event.reason || 'Relay disconnected before authentication'));
    });
  });
}